import { CalculaterForm } from "./calculaterForm";
import PropTypes from "prop-types";

/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect } from "react";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import Fuse from "fuse.js";
import Fuzzy from "fuzzy";

import ratecart from "./data.json";

import calculeterIcon from "../../assests/images/calculeterIcon.svg";
import InsuranceIcon from "../../assests/images/Insurance.svg";
import messages from "../../constants/messages";

import ritTick from "../../assests/images/ritTick.svg";
import { Form, Row, Col, Checkbox, Button, Spin, message } from "antd";
import {
  clearBarcodeId,
  clearChildPacketIds,
  clearPostShipment,
  clearUpdateShipment,
  getUser,
} from "../../actionsMethods/cashBookingMethods";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  getServiceAbilityCheck,
  getServiceAbilityCheckReset,
  getPinCodeArea,
  getCalculaterRateChart,
  getCalculaterRateChartClear,
} from "../../actionsMethods/cashBookingMethods";

import RateCard1 from "./RateCard/newRateCard";
import { priceCal } from "./RateCard/rateCardLogic";
import { listOfServies } from "./RateCard/listOfServies";
import API from "../../api";
import urls from "../../api/urls";

import {
  getBarcodeId,
  postShipment,
} from "../../actionsMethods/cashBookingMethods";
import axios from "axios";
import { APIs, getToken, getPremiseId } from "../../utils/worker";

function Calculator({ screen, currentScreen }) {
  const navigate = useNavigate();
  const myRef = React.useRef(null);
  const { GET_AREA_PREMISE_ID, GET_RATE_CARD } = urls;
  const scrollDiv = () => myRef.current.scrollTo(0, 50);
  const standard = ratecart.data.ratechart[0].services[0];
  const fastTrack = ratecart.data.ratechart[0].services[1];
  const valuePluse = ratecart.data.ratechart[0].services[2];
  const token = getToken();

  const [form] = Form.useForm();
  const user_premiseId = JSON.parse(window?.localStorage?.getItem("userId"));
  const usertoken = JSON.parse(window?.localStorage?.getItem("userinfo"));

  const CheckboxGroup = Checkbox.Group;
  const [details, setDetails] = useState(
    JSON.parse(window?.localStorage?.getItem("details")) || {}
  );
  const [selectedArea, setSelectedArea] = useState("");
  console.log(selectedArea);
  const [calShow, setCalShow] = useState(false);
  const [validorNot, setValidorNot] = useState({});

  const [selectedId, setSelectedId] = useState();
  const [rateCatdResponse, setRateCatdResponse] = useState([]);
  const [nonDox, setNonDox] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const serviceabilityCheckResponse = useSelector(
    (state) => state?.appReducer?.getServiceAbilityCheckReducer,
    shallowEqual
  );

  const areaDropDown = useSelector(
    (state) => state?.appReducer?.getPinCodeAreaReducer,
    shallowEqual
  );
  const [searchData, setSearchData] = useState(
    serviceabilityCheckResponse?.result?.areas
  );
  const [querydata, setQuerydata] = useState(null);

  const [data, setData] = useState(false);

  const [childLength, setChildLength] = React.useState(false);
  const dispatch = useDispatch();

  const [allTotal, setAllTotal] = React.useState({});
  const pickUpPinCode = useSelector(
    (state) => state.appReducer.getUser,
    shallowEqual
  );

  const [destinationPremiseId, setDestinationPremiseId] = useState("");
  useEffect(() => {
    setSelectedId(undefined);
  }, [nonDox, calShow]);

  useEffect(() => {
    if (currentScreen === 0) {
      setAllTotal({});
      dispatch(clearChildPacketIds());
      dispatch(getServiceAbilityCheckReset());
      dispatch(clearUpdateShipment());
      dispatch(clearBarcodeId());
      dispatch(clearPostShipment());
    }
  }, [currentScreen]);

  const { fetching, result } = pickUpPinCode;

  const tatService = useSelector(
    (state) => state?.appReducer?.getCalculaterTatChartReducer,
    shallowEqual
  );

  const { result: seriviceResult } = serviceabilityCheckResponse;
  const disabledOrNot = serviceabilityCheckResponse?.error ? true : false;

  const {
    SHIPPING_RATE_CALCULATOR,
    PICKUP_PINCODE,
    DELIVERY_PINCODE,
    TYPE,
    CALCULATE,
    AREA,
    CONTENT,
    DESCRIPTIONS,
    SERVICES,
  } = messages;

  useEffect(() => {
    if (user_premiseId === null) {
      navigate("/dashboard");
    }
    setCalShow(false);
    dispatch(getServiceAbilityCheckReset());
  }, []);

  useEffect(() => {
    if (serviceabilityCheckResponse.fetching == false) {
      pinCodeVlidater();
    }
  }, [serviceabilityCheckResponse.fetching]);

  const pinCodeVlidater = () => {
    if (
      serviceabilityCheckResponse.fetching == false &&
      serviceabilityCheckResponse?.error
    ) {
      setValidorNot({
        validateStatus: "error",
        errorMsg: serviceabilityCheckResponse?.error?.message,
      });
    } else if (
      serviceabilityCheckResponse?.fetching == false &&
      disabledOrNot
    ) {
      setValidorNot({
        validateStatus: "error",
        errorMsg: serviceabilityCheckResponse?.result?.message,
      });
    } else if (
      serviceabilityCheckResponse?.fetching == false &&
      serviceabilityCheckResponse?.result === "non serviceable pincode"
    ) {
      setValidorNot({
        validateStatus: "error",
        errorMsg: serviceabilityCheckResponse?.result,
      });
      setSearchData(serviceabilityCheckResponse?.result?.areas);
    } else {
      setValidorNot({
        validateStatus: "success",
        errorMsg: null,
      });
    }
  };

  useEffect(() => {
    if (!tatService?.error) {
      // scrollDiv();
      // scrollTo(0, 450,behavior:);
      setCalShow(true);
    } else {
      message.error(tatService?.error?.message);
    }
    if (tatService.fetching == false && tatService?.result !== null) {
      let temp = [];
      for (let i = 0; i < rateCatdResponse.length; i++) {
        let mode =
          rateCatdResponse[i]?.serive.replace(/ +/g, "") +
          rateCatdResponse[i]?.modeName;
        let x = tatService?.result?.data;
        temp.push({
          ...rateCatdResponse[i],
          tatService:
            mode.toLowerCase() === "standardsurface"
              ? x?.standardSurfaceDays
              : mode.toLowerCase() === "standardair"
              ? x?.standardAirDays
              : mode.toLowerCase() === "valueplusair"
              ? x?.valueAirDays
              : mode.toLowerCase() === "valueplussurface"
              ? x?.valueSurfaceDays
              : mode.toLowerCase() === "fasttrackair"
              ? x?.expressAirDays
              : mode.toLowerCase() === "fasttracksurface"
              ? x?.expressSurfaceDays
              : "",
        });
      }
      setRateCatdResponse(temp);

      scrollTo({
        top: document.getElementById("refId").offsetTop + 145,
        left: 0,
        behavior: "smooth",
      });

      // scrollTo({
      //   top: document.getElementById("refId").offsetTop + 145,
      //   left: 0,
      //   behavior: "smooth",
      // });
    }
  }, [tatService, tatService.fetching]);

  useEffect(() => {
    form.setFieldsValue({
      pickupPincode: result?.pin,
    });
    setSelectedId();
    setSearchData(serviceabilityCheckResponse?.result?.areas);
  }, [fetching, serviceabilityCheckResponse?.fetching]);

  useEffect(() => {
    setSearchData(searchData);
  }, [querydata]);

  const myFUnction = (e) => {
    dispatch(getServiceAbilityCheck(e.target.value, usertoken.accessToken));
    // dispatch(getPinCodeArea(e.target.value));
  };

  const inputHandler = (e) => {
    setCalShow(false);
    dispatch(getServiceAbilityCheckReset());
    form.setFieldsValue({ area: null });
    if (e.target.value.length > 5) {
      myFUnction(e);
      // senderSms(e);
    }
  };

  const checkNumbervalue = (event) => {
    if (!/^[0-9]*\.?[0-9]*$/.test(event.key) && event.key !== "Backspace") {
      return true;
    }
  };

  const getRateCard = async (values) => {
    setLoading(true);
    let ttvw = 0;
    if (values?.child_Selected) {
      if (+values?.weight < +allTotal?.totalOfTotal + +values?.totalVolWeight) {
        ttvw = +values?.totalVolWeight + +allTotal?.totalOfTotal;
      } else {
        ttvw = +values?.weight;
      }
    } else {
      if (+values?.weight < values?.totalVolWeight) {
        ttvw = +values?.totalVolWeight;
      } else {
        ttvw = +values?.weight;
      }
    }

    let weight = values?.docType == "DOX" ? values?.weight : +ttvw;

    let response = await API.Api(
      GET_RATE_CARD +
        `${
          user_premiseId?.premises?.pincode + "/to/" + values?.deliveryPincode
        }`
    ).postCustomHeader(
      {
        areaId: destinationPremiseId,
        type: values?.docType == "DOX" ? "DOX" : "NON_DOX",
        content: "Documents",
        description: "some desc",
        weight: weight,
      },
      {
        "SMCS-PREMISE-ID": user_premiseId?.userInfo?.premiseId,
        clientId: 0,
      }
    );

    if (response.status) {
      let x = response.response.data.data.services;

      var temp = [];
      for (let i = 0; i < x.length; i++) {
        for (let j = 0; j < x[i].rates.length; j++) {
          temp.push({
            id: i + "_" + j + "_" + 1,
            serive: x[i].serviceType,
            modeName: x[i].rates[j].mode,
            price: x[i].rates[j].rate,
            color:
              x[i].serviceType == "FAST TRACK"
                ? "orange"
                : x[i].serviceType == "STANDARD"
                ? "blue"
                : "green",
            tatService: "120",
            cod: response?.response?.data?.data?.codCharges,
            fov: response?.response?.data?.data?.fov,
          });
        }
      }

      setRateCatdResponse(temp);
      dispatch(
        getCalculaterRateChart({
          to: user_premiseId?.premises?.pincode,
          from: values?.deliveryPincode,
          destinationPremiseId,
        })
      );
      setLoading(false);
    } else {
      message.error("Somthing went wrong");
      setLoading(false);
    }
  };

  const onSubmit = (values) => {
    setRateCatdResponse([]);
    dispatch(getCalculaterRateChartClear());

    getRateCard(values);

    let ss = values?.docType;
    let ttvw = 0;
    if (values?.child_Selected) {
      if (+values?.weight < +allTotal?.totalOfTotal + +values?.totalVolWeight) {
        ttvw = +values?.totalVolWeight + +allTotal?.totalOfTotal;
      } else {
        ttvw = +values?.weight;
      }
    } else {
      if (+values?.weight < values?.totalVolWeight) {
        ttvw = +values?.totalVolWeight;
      } else {
        ttvw = +values?.weight;
      }
    }

    let weight = values?.docType == "DOX" ? values?.weight : +ttvw;

    let standareAir = priceCal(standard, ss, "Air", "METRO", weight);
    let standareSurface = priceCal(standard, ss, "Surface", "METRO", weight);
    let fastSurface = priceCal(fastTrack, ss, "Surface", "METRO", weight);
    let fastAir = priceCal(fastTrack, ss, "Air", "METRO", weight);
    let valueAir = priceCal(valuePluse, ss, "Air", "METRO", weight);
    let valueSurface = priceCal(valuePluse, ss, "Surface", "METRO", weight);

    delete values.pickupPincode;
    return getAllPrice(
      standareAir,
      standareSurface,
      fastSurface,
      fastAir,
      valueAir,
      valueSurface,
      values
    );
  };

  const getAllPrice = (
    standareAir,
    standareSurface,
    fastSurface,
    fastAir,
    valueAir,
    valueSurface,
    values
  ) => {
    let pickupPincode = user_premiseId?.premises?.pincode;
    let data1 = {
      ...values,
      valueInr:
        values?.valueInrNonDox === undefined
          ? values?.valueInrDox
          : values?.valueInrNonDox,
    };
    let newDetails = {
      standareAir,
      standareSurface,
      fastSurface,
      fastAir,
      valueAir,
      valueSurface,
      values,
      ...data1,
      pickupPincode,
      seriviceResult,
      selectedArea,
      destinationPremiseId,
    };
    // dispatch(
    //   getCalculaterRateChart({
    //     to: user_premiseId?.premises?.pincode,
    //     from: values?.deliveryPincode,
    //     destinationPremiseId,
    //   })
    // );

    setDetails(newDetails);
    window.localStorage.setItem("details", JSON.stringify(newDetails));
  };
  let { allserives, serivesSurat } = listOfServies(details, tatService);

  const [errorMsg, setErrorMsg] = useState("");

  function handleNext() {
    if (selectedId !== undefined) {
      dispatch(getCalculaterRateChartClear());
      screen(1);
    } else {
      setErrorMsg("please select service");
    }
  }

  const getAreaPremiseId = async (values) => {
    let response = await axios.get(
      APIs.baseURL + `/premise-service/v1/premise/areas/premise-id/${values}`,
      {
        headers: {
          Authorization: token,
        },
      }
    );
    if (response.status == 200) {
      setDestinationPremiseId(response.data);
    } else {
      // sentPhoneOtp(values);
      message.error("somthing went wrong");
    }
  };

  const handleOnChange = (e, v) => {
    setSelectedArea({ id: v?.key, value: e });
    setSearchData(serviceabilityCheckResponse?.result?.areas);
    getAreaPremiseId(v?.key, e);
  };

  const searchArea = (query) => {
    setCalShow(false);
    if (!query) {
      setSearchData(areaDropDown?.result);
      return;
    }
    const fuse = new Fuse(areaDropDown?.result, {
      keys: ["areaName"],
    });
    const result = fuse.search(query);
    const finalResult = [];
    if (result.length) {
      result.forEach((item) => {
        finalResult.push(item.item);
      });
      setSearchData(finalResult);
    } else {
      setSearchData([]);
    }
  };

  useEffect(() => {
    dispatch(getServiceAbilityCheckReset());
    setValidorNot({});
  }, []);

  // const searchArea = (query) => {
  //   var options = {
  //     pre: "<",
  //     post: ">",
  //     extract: function (el) {
  //       return el?.areaName;
  //     },
  //   };
  //   var results = Fuzzy.filter(
  //     query,
  //     serviceabilityCheckResponse?.result?.response2,
  //     options
  //   ).map((item) => item?.original);

  //   setCalShow(false);

  //   if (!query) {
  //     setSearchData(serviceabilityCheckResponse?.result?.response2);
  //     return;
  //   }

  //   if (results.length) {
  //     setSearchData(results);
  //     setQuerydata(results.length);
  //   } else {
  //     setSearchData([]);
  //   }
  // };\\

  console.log({ rateCatdResponse }, { tatService });

  return (
    <div className="calculater-containerbox">
      <Spin
        spinning={
          serviceabilityCheckResponse?.fetching ||
          fetching ||
          loading ||
          tatService.fetching
        }
      >
        <div className="parentDiv">
          <div className="first">
            <div className="calculater-containerbox-header">
              <img
                width="20px"
                height="20px"
                className="messageIcon"
                src={calculeterIcon}
              />
              <span className="calculater-containerbox-header-text">
                {SHIPPING_RATE_CALCULATOR}
              </span>
              <div className="calculater-containerbox-bottomLine"></div>
            </div>
            <div className="calculater-containerbox-card">
              <Form
                layout="vertical"
                form={form}
                onFieldsChange={(a) => setData(!data)}
                scrollToFirstError={{
                  behavior: "smooth",
                  block: "center",
                  inline: "center",
                }}
                initialValues={{
                  docType: "DOX",
                  content: "Document",
                }}
                onFinish={onSubmit}
              >
                <CalculaterForm
                  PICKUP_PINCODE={PICKUP_PINCODE}
                  result={user_premiseId?.premises?.pincode}
                  statusCode={user_premiseId?.premises?.stateCode}
                  validorNot={validorNot}
                  errorMsg={errorMsg}
                  DELIVERY_PINCODE={DELIVERY_PINCODE}
                  checkNumbervalue={checkNumbervalue}
                  inputHandler={inputHandler}
                  serviceAblePincode={serviceabilityCheckResponse?.result}
                  searchArea={searchArea}
                  AREA={AREA}
                  form={form}
                  disabledOrNot={disabledOrNot}
                  handleOnChange={handleOnChange}
                  searchData={searchData}
                  TYPE={TYPE}
                  nonDox={nonDox}
                  setNonDox={setNonDox}
                  setCalShow={setCalShow}
                  CONTENT={CONTENT}
                  DESCRIPTIONS={DESCRIPTIONS}
                  setChildLength={setChildLength}
                  childLength={childLength}
                  data={data}
                  allTotal={allTotal}
                  setAllTotal={setAllTotal}
                />

                <Row
                  style={{ padding: "0 75px 10px 0px" }}
                  justify="end"
                  ref={myRef}
                >
                  <Col id="refId" className="cal-submit" span={8} offset={2}>
                    <Button
                      className="calculate-btn"
                      htmlType="submit"
                      value="Submit"
                      // disabled={disabledOrNot}
                      type="primary"
                    >
                      {CALCULATE}
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>

        {tatService?.result !== null &&
        rateCatdResponse.length > 0 &&
        calShow ? (
          <>
            <div style={{ padding: "0 80px" }}>
              {" "}
              <div className="calculater-containerbox-insuranceBox">
                <img
                  width="20px"
                  height="20px"
                  className="messageIcon"
                  src={InsuranceIcon}
                />
                <span className="calculater-containerbox-insurance">
                  {SERVICES}
                </span>
              </div>
              <div className="calculater-containerbox-bottomLine"></div>
              <Row gutter={[24, 30]} justify="start" className="cardsGap">
                {user_premiseId?.premises?.city == "Rajkot"
                  ? rateCatdResponse?.map((item, i) => (
                      <>
                        <Col xs={22} sm={20} md={12} lg={6} key={i}>
                          <RateCard1
                            key={i}
                            item={item}
                            setSelectedId={setSelectedId}
                            setErrorMsg={setErrorMsg}
                            borderColor={
                              item.id == selectedId?.id
                                ? selectedId?.color
                                : "transparent"
                            }
                            buttonColor={
                              item.id == selectedId?.id ? "#2E77D0" : ""
                            }
                            buttonTextColor={
                              item.id == selectedId?.id ? "#FFFFFF" : ""
                            }
                            ritTick={item.id == selectedId?.id ? ritTick : ""}
                            premiumOrnot={
                              serviceabilityCheckResponse?.result?.data
                                ?.serviceability
                            }
                          />
                        </Col>
                      </>
                    ))
                  : rateCatdResponse
                      .filter((e) => e.serive !== "VALUE PLUS")
                      .map((item, i) => (
                        <>
                          <Col xs={22} sm={20} md={12} lg={6} key={i}>
                            <RateCard1
                              key={i}
                              item={item}
                              setSelectedId={setSelectedId}
                              setErrorMsg={setErrorMsg}
                              borderColor={
                                item.id == selectedId?.id
                                  ? selectedId?.color
                                  : "transparent"
                              }
                              buttonColor={
                                item.id == selectedId?.id ? "#2E77D0" : ""
                              }
                              buttonTextColor={
                                item.id == selectedId?.id ? "#FFFFFF" : ""
                              }
                              ritTick={item.id == selectedId?.id ? ritTick : ""}
                              premiumOrnot={
                                serviceabilityCheckResponse?.result?.data
                                  ?.serviceability
                              }
                            />
                          </Col>
                        </>
                      ))}
              </Row>
            </div>
            <div>
              <p style={{ color: "red", padding: "0 80px 19px 80px " }}>
                {errorMsg}
              </p>
              <div className="calculater-containerbox-bottomLine"></div>
              <Row className="button-container1" justify="end">
                <Col>
                  <div className="steps-action">
                    <Button
                      onClick={() => navigate("/dashboard")}
                      className="cancle-button"
                    >
                      {"CANCEL"}
                    </Button>
                  </div>
                </Col>
                <Col>
                  <div className="steps-action">
                    <Button
                      htmlType="submit"
                      onClick={handleNext}
                      className="next-button"
                    >
                      {"NEXT"}
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </>
        ) : (
          ""
        )}
      </Spin>
    </div>
  );
}

Calculator.propTypes = {
  screen: PropTypes.any,
};

export default Calculator;
